import React from 'react';
export var MessageIcon = function (_a) {
    var iconFileUrl = _a.iconFileUrl;
    return (React.createElement("div", { className: "ffe-message__icon-container" },
        React.createElement("div", { className: "ffe-message__icon", style: iconFileUrl
                ? {
                    maskImage: "url(".concat(iconFileUrl, ")"),
                    WebkitMaskImage: "url(".concat(iconFileUrl, ")"),
                }
                : undefined })));
};
